import themesValueSet from "../fhir/ValueSet/upcare-themes.valueset.json";

export type UpCareThemeCode =
    | "management"
    | "gardes"
    | "achat"
    | "gestion-conflit"
    | "nouvel-arrivant"
    | "qvt"
    | "qualite"
    | "logistique"
    | "montage-projet";

export interface UpCareTheme {
    code: UpCareThemeCode;
    display: string;
    system: string;
}

const include = themesValueSet.compose.include[0];

export const UPCARE_THEME_SYSTEM = include.system;

export const UPCARE_THEMES: UpCareTheme[] = include.concept.map((concept) => ({
    code: concept.code as UpCareThemeCode,
    display: concept.display,
    system: include.system
}));

export const getUpCareTheme = (code?: string): UpCareTheme | undefined =>
    UPCARE_THEMES.find((theme) => theme.code === code);

export const getUpCareThemeDisplay = (code?: string): string | undefined =>
    getUpCareTheme(code)?.display;

export const getUpCareThemeCode = (resource: unknown): UpCareThemeCode | undefined => {
    let result: UpCareThemeCode | undefined;

    const visit = (value: unknown) => {
        if (result || !value || typeof value !== "object") return;
        if (Array.isArray(value)) {
            value.forEach(visit);
            return;
        }

        const object = value as Record<string, unknown>;
        if (
            object.system === UPCARE_THEME_SYSTEM &&
            typeof object.code === "string" &&
            getUpCareTheme(object.code)
        ) {
            result = object.code as UpCareThemeCode;
            return;
        }

        Object.values(object).forEach(visit);
    };

    visit(resource);
    return result;
};
